// extracted by mini-css-extract-plugin
module.exports = {"configurer":"Configurer_configurer__3GXan","configurerSidebarMinimized":"Configurer_configurerSidebarMinimized__3kXX5"};